import { Component, OnInit } from '@angular/core';
import { APPCONFIG } from '../../config';
import { TranslateService } from 'ng2-translate';

@Component({
    selector: 'my-app-header',
    styles: [],
    template: require('./header.component.html')
})

export class AppHeaderComponent implements OnInit {
    constructor(private translate: TranslateService) {
    }
    
    public AppConfig: any;
    language:string;

    ngOnInit() {
        this.AppConfig = APPCONFIG;
        this.language = this.translate.currentLang;
    }

    changeLanguage() {
        
        this.translate.use(this.language);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/header/header.component.ts